import {
  applyMiddleware,
  combineReducers,
  legacy_createStore,
  compose,
} from "redux";
import { thunk } from "redux-thunk";

import { reducer as appReducer } from "./app/app.reducer";
import { reducer as authReducer } from "./auth/auth.reducer";
import { reducer as compareReducer } from "./compare/compare.reducer";
import { reducer as bookmarkReducer } from "./bookmarks/bookmark.reducer";
import { reducer as hospitalReducer } from "./hospital/hospital.reducer";
import { reducer as sortingModelReducer } from "./sortingModel/sortingModel.reducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  compare: compareReducer,
  bookmarks: bookmarkReducer,
  hospital: hospitalReducer,
  sortingModel: sortingModelReducer,
});

export const store = legacy_createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk)),
);
